export default "<div role=\"tablist\">\n  <slot></slot>\n</div>\n";